module.exports = __webpack_public_path__ + "media/images/athletes/4149-0d8aba12a20a06c3bc4110154939f7b6.png";